import { Pipe, PipeTransform } from '@angular/core';
import { AbstractControl, FormGroup } from '@angular/forms';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { combineLatest, Observable } from 'rxjs';
import { debounceTime, map } from 'rxjs/operators';

@Pipe({
  name: 'formDebug',
})
export class FormDebugPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  transform(form: FormGroup, fieldName?: string): Observable<SafeHtml> {
    return combineLatest([form.valueChanges, form.statusChanges]).pipe(
      debounceTime(1),
      map(() => {
        const result: string = this.formState(form, fieldName);
        return this.sanitizer.bypassSecurityTrustHtml(result);
      }),
    );
  }

  private formState(form: FormGroup, fieldName?: string): string {
    return `<div class="w-full">
            <b>Valid</b>: ${form.valid}<br />
            <b>Pristine</b>: ${form.pristine}<br />
            <b>Dirty</b>: ${form.dirty}<br />
            <b>Touched</b>: ${form.touched}<br />
            <b>Errors</b>:<br />
            ${this.getErrors('form', form).join('<br />')}<br />
            <b title='${JSON.stringify(fieldName ? form.value[fieldName] : form.value)}'>Value</b>
        </div>`;
  }

  private getErrors(name: string, item: AbstractControl): string[] {
    const errors: string[] = item.errors
      ? Object.keys(item.errors).map((key: string) => `${name}: ${key} - ${JSON.stringify(item.errors[key])}`)
      : [];

    return [
      ...errors,
      ...(item['controls' as keyof AbstractControl]
        ? Object.keys(item['controls' as keyof AbstractControl]).flatMap((key: string) =>
            this.getErrors(`${name}.${key}`, item['controls' as keyof AbstractControl][key]),
          )
        : []),
    ];
  }
}
